import { Link } from 'react-router';

import { Card } from '@/components/ui/card';

import { AppCardProvider, type AppCardData } from '../model';

import { AttentionStrip } from './AttentionStrip';
import { Footer } from './Footer';
import { Header } from './Header';
import { TagRow } from './TagRow';
import { Watermark } from './Watermark';

type AppCardProps = {
  data: AppCardData;
  onAddProtection?: () => void;
};

const AppCard = ({ data, onAddProtection }: AppCardProps) => {
  return (
    <AppCardProvider data={data} onAddProtection={onAddProtection}>
      <Card className="group rounded-lg relative overflow-hidden min-h-59 h-full flex transition-[translate,box-shadow] duration-200 translate-y-0 hover:shadow-lg hover:-translate-y-0.75 ease-linear">
        <Watermark />
        <Link
          to={`/applications/${data.appId}`}
          className="relative p-4 z-2 flex flex-col justify-between gap-2 grow min-w-0"
        >
          <AttentionStrip />
          <Header />
          <TagRow />
          <Footer />
        </Link>
      </Card>
    </AppCardProvider>
  );
};

export { AppCard };
export type { AppCardProps };
